import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=63263597&scoped=true"
import script from "./PaymentMethod.vue?vue&type=script&lang=ts"
export * from "./PaymentMethod.vue?vue&type=script&lang=ts"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&id=63263597&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63263597",
  null
  
)

export default component.exports